type TitleFields = {
  resolvedTitleEn: string | null;
  resolvedTitleAr: string;
  productNameEn: string | null;
  productNameAr: string;
};

export function resolveItemTitle(item: TitleFields, locale: string): string {
  if (locale === "ar") {
    return (
      item.resolvedTitleAr ||
      item.productNameAr ||
      item.resolvedTitleEn ||
      item.productNameEn ||
      ""
    );
  }
  return (
    item.resolvedTitleEn ||
    item.resolvedTitleAr ||
    item.productNameEn ||
    item.productNameAr ||
    ""
  );
}
